const STORAGE_KEY='turbo-crown-input-telemetry-v1';

const emptyBucket=()=>({matches:0,completed:0,seconds:0,shots:0,hits:0,eliminations:0});

function normalized(value){
  const source=value&&typeof value==='object'?value:{};
  const bucket=(entry={})=>Object.fromEntries(Object.keys(emptyBucket()).map((key)=>[
    key,Math.max(0,Number(entry[key])||0),
  ]));
  return {
    version:1,
    'keyboard-mouse':bucket(source['keyboard-mouse']),
    gamepad:bucket(source.gamepad),
  };
}

export class InputTelemetry {
  constructor(storage=globalThis.localStorage){
    this.storage=storage;
    this.active=null;
    try{this.data=normalized(JSON.parse(storage?.getItem?.(STORAGE_KEY)||'{}'));}
    catch{this.data=normalized();}
  }

  begin(device,mode='unknown'){
    if(this.active)this.finish(false);
    const inputDevice=device==='gamepad'?'gamepad':'keyboard-mouse';
    this.active={device:inputDevice,mode,startedAt:performance.now(),shots:0,hits:0,eliminations:0};
    this.data[inputDevice].matches+=1;
    this.persist();
  }

  shot(){if(this.active)this.active.shots+=1;}
  hit(){if(this.active)this.active.hits+=1;}
  elimination(){if(this.active)this.active.eliminations+=1;}

  finish(completed=true){
    if(!this.active)return;
    const bucket=this.data[this.active.device];
    bucket.completed+=completed?1:0;
    bucket.seconds+=Math.max(0,(performance.now()-this.active.startedAt)/1000);
    bucket.shots+=this.active.shots;
    bucket.hits+=this.active.hits;
    bucket.eliminations+=this.active.eliminations;
    this.active=null;
    this.persist();
  }

  persist(){
    try{this.storage?.setItem?.(STORAGE_KEY,JSON.stringify(this.data));}catch{/* Storage privado o lleno. */}
  }

  snapshot(){
    return typeof structuredClone==='function'
      ?structuredClone(this.data)
      :JSON.parse(JSON.stringify(this.data));
  }
}
